<template lang="pug">
  .table-wrap
    .historical-table(v-if="!emptyModifications")
      .theader
        .th(v-for="({label}, i) in parseRow()", :class="label | toKebabCase", :key="i")
          label.th-label.ellipsis {{label}}
      .tbody
        .table-row(v-for="(row, i) in tableData", :key="i")
          .table-cells
            .table-cell(v-for="({value, label}, i) in parseRow(row)", :key="i", :class="label | toKebabCase")
              p.label {{label}}:
              a.value.ellipsis {{ value }}
      t-pagination(
      :current-page="timelineTable.currentPage", :last-page="timelineTable.lastPage", :per-page="timelineTable.perPage",
      entities="modifications", @set-page="setPage", @next="setPage", @prev="setPage", @set-per-page="changePerPage")
    .empty(v-else)
      p.info No historical data available for {{companyName}}
</template>
<script>
import kebabCase from 'lodash/kebabCase'
import { mapGetters, mapState, mapActions, } from 'vuex'
import moment from 'moment'
import TPagination from '../../data-table/TPagination'

export default {
  components: { TPagination, },
  filters: {
    toKebabCase: (val) => kebabCase(val),
    timeFormat: (val) => moment(val, moment.ISO_8601, true).isValid() ? moment(val).format('YYYY-MM-DD') : val,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {}
  },
  computed: {
    emptyModifications () {
      return !this.tableData.length
    },

    ...mapState('record', [ 'timelineTable', 'record', ]),
    ...mapGetters('record', [ 'companyName', ]),
  },
  methods: {
    changePerPage (val) {
      this.getModifications({
        id: this.record.id,
        page: {
          number: this.timelineTable.currentPage,
          size: val,
        },
      })
    },
    setPage (val) {
      this.getModifications({
        id: this.record.id,
        page: {
          number: val,
          size: this.timelineTable.perPage,
        },
      })
    },
    parseRow (row = {}) {
      const { timeFormat, } = this.$options.filters
      return [
        {
          label: 'Modification Date',
          value: timeFormat(row.publish_start),
        },
        {
          label: 'LEI Field',
          value: row.field,
        },
        {
          label: 'New Value',
          value: row.value_new,
        },
        {
          label: 'Old Value',
          value: row.value_old,
        },
      ]
    },

    ...mapActions('record', [ 'getModifications', ]),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"
  .empty
    color $default-color-middle
    padding 15px 0

  .historical-table
    font-size 90%
    display flex
    flex-direction column

    .theader, .table-cells
      .modification-date
        width 17.5%
      .lei-field
        width 37.5%
      .new-value
        width 22.5%
      .old-value
        width 22.5%

    .theader
      display flex
      .th
        padding 0 30px
        height 40px
        display flex
        align-items center
        color $default-color-bold
        font-weight 600

    .tbody
      display flex
      flex-direction column
      border 1px solid $default-color-light-1
    .table-row
      display flex

    .table-cells
      width 100%
      display flex
      justify-content space-between
      min-height 50px

    .status-icon
      margin-right 8px
    .label
      display none
    .value
      color $default-color-bold
      line-height 1.25
      overflow hidden
      text-overflow ellipsis
    .table-cell
      border 1px solid $default-color-light-1
      display flex
      padding 10px 30px
      align-items center

      &.modification-date
        justify-content center
        .value
          line-height 1.5
          border-bottom 2px solid $info-color
      &.old-value
        .value
          color $default-color-middle-1

  @media screen and (max-width: $laptop)
    .empty
      padding 15px 20px

    .historical-table
      .theader
        display none
      .table-row
        flex-direction column
      .table-cells
        display flex
        flex-direction column
        border-bottom 1px solid $default-color-light-1
        padding 5px 20px
        .table-cell
          border none
          display flex
          align-items center
          padding 4px 0
          width 100%
          line-height 1.2
          .label
            display block
            white-space nowrap
            color $default-color-middle
            font-weight 600
          .value
            margin-left 10px
          &.modification-date
            justify-content flex-start
            .value
              border-bottom 1px solid $info-color
          &.old-value
            .value
              color $default-color-middle-1

  @media screen and (max-width: $tablet)
    .empty
      padding 15px 20px

    .historical-table
      .tbody
        font-size 95%
        border none

  /*.status-icon
    margin-right 8px

  .table-cell
    border 1px solid $default-color-light-1
    display flex
    padding 10px 30px
    align-items center
    .value
      color $default-color-bold
      line-height 1.25rem
      overflow hidden
      text-overflow ellipsis
    &.modification-date
      justify-content center
      .value
        line-height 1.5rem
        border-bottom 2px solid $info-color
    &.old-value
      .value
        color $default-color-middle-1*/
</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/HistoricalTable.vue